import {BaseModel} from "./base";

export class GroupModel extends BaseModel {
  id: Number;
  adminId: Number;
  membersCount: Number;
  averageScore: Number;
  name: String;
  imageURL: String;
  invitationLink: String;
  isAdmin: Boolean;
  preventLeave: Boolean;
  preventSetMaster: Boolean;
  userRank: Number;

  constructor(model) {
    super(model);

    this.id = model.groupID;
    this.adminId = model.adminID;
    this.membersCount = model.membersCount;
    this.userRank = model.userRank;
    this.averageScore = model.averageScore?.toFixed(2);
    this.name = model.name;
    this.imageURL = model.imageURL.replace('http://', 'https://').replace('imagescache', 'imagecache');
    this.invitationLink = model.invitationLink;
    this.isAdmin = model.isAdmin;
    this.preventLeave = model.preventLeave;
    this.preventSetMaster = model.preventSetMaster;
  }

  get membersCountDisplay() {
    return this.formatNumber(this.membersCount)
  }

  get userRankDisplay() {
    return this.numberWithCommas(this.userRank)
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatNumber(x) {
    if (x >= 1000000) {
      return (x / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }

    if (x >= 100000) {
      return (x / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }

    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
